module.exports = __webpack_public_path__ + "img/logo_new.63d1acf7.png";